import { articulosSelector } from "features/Inventario/redux/selectors/articulosSelectors"
import { getCatalogoSelector } from "features/Inventario/redux/selectors/catalogosSelector"
import {
  clearArticuloState,
  getArticulosByCatalogoIdEncrypted,
} from "features/Inventario/redux/slices/articulosSlice"
import { getCatalogoEncrypted } from "features/Inventario/redux/slices/catalogosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback, useEffect } from "react"
import { useParams } from "react-router-dom"
import ViewCatalogo from "../ViewCatalogo/ViewCatalogo"

const ViewSharedCatalogo = () => {
  const { catalogo, categorias } = useSelector(getCatalogoSelector)
  const { searchArticuloName, articulosGroupedByCategoria, fetchingArticulos } =
    useSelector(articulosSelector)

  const params = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(clearArticuloState())
    dispatch(clearArticuloState())
  }, [dispatch])

  useEffect(() => {
    dispatch(getCatalogoEncrypted(params.id))
    // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
    dispatch(getArticulosByCatalogoIdEncrypted({ catalogoId: params.id }))
  }, [dispatch, params])

  const filterArticulos = useCallback(
    (filters: $TSMigrationFixMe) => {
      dispatch(
        getArticulosByCatalogoIdEncrypted({
          catalogoId: params.id,
          ...filters,
        })
      )
    },
    [dispatch, params]
  )

  return (
    <ViewCatalogo
      articulosGroupedByCategoria={articulosGroupedByCategoria}
      categorias={categorias}
      filterArticulos={filterArticulos}
      searchArticuloName={searchArticuloName}
      fetchingArticulos={fetchingArticulos}
      catalogo={catalogo}
      isSharedCatalogo
    />
  )
}

export default ViewSharedCatalogo
